<template>
  <div>
    <v-dialog v-model="dialog" width="500" height="1500">
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex flex-row justify-center">
          <v-btn outlined color="primary" v-bind="attrs" v-on="on">
            New Channel
          </v-btn>
        </div>
      </template>

      <v-card>
        <v-card-title class="text-h5  lighten-2 mb-2">
          New Channel
        </v-card-title>
        <v-card-text>
          <v-form class="mb-6">
            <v-text-field
              v-model="selectedTitleForConvo"
              label="Channel Name"
            ></v-text-field>
          </v-form>

          <v-form ref="accountform" v-model="valid">
            <v-autocomplete
              auto-select-first
              :items="acls"
              item-text="username"
              item-value="username"
              attach
              chips
              clear-icon="mdi-close-circle"
              clearable
              multiple
              @click:clear="clear"
              hide-selected
              label="Select Accounts"
              v-model="selectedAccountsForConvo"
              ref="accountSelect"
              hint="Please select who should be part of this channel"
              persistent-hint
            >
              <template v-slot:selection="{ attr, on, item, selected }">
                <v-chip
                  v-bind="attr"
                  :input-value="selected"
                  color="#78909c"
                  class="white--text"
                  v-on="on"
                >
                  <v-icon left>mdi-coin</v-icon>
                  <span v-text="item.username"></span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="
              !selectedTitleForConvo || selectedAccountsForConvo.length === 0
            "
            @click="createConversation()"
          >
            Create Channel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    acls: Array,
    currentlySelectedAccount: String,
    recordsIamAuthorizedOn: Array,
  },
  data() {
    return {
      dialog: false,
      selectedAccountsForConvo: [],
      selectedTitleForConvo: "",
      valid: false,
    };
  },
  computed: {},
  methods: {
    clear() {
      this.selectedAccountsForConvo = [];
    },
    async createConversation() {
      let newConvoObj = {
        conversation_name: this.selectedTitleForConvo,
        account_name: this.currentlySelectedAccount,
        recipients: this.selectedAccountsForConvo,
      };
      let conversation = await this.$store.dispatch(
        "newConversation",
        newConvoObj
      );
      this.$emit("refreshconversations");

      this.dialog = false;
    },
  },
};
</script>

<style></style>
